import React from "react";

import {
  Button,
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Stack,
} from "@mui/material";
import { Setting, MessageNotif, Message2 } from "iconsax-reactjs";
import { useOrderFilter } from "./hooks/useOrderFilter";

import "./order-filter.styles.css";
import Typography from "../Typography";

const OrderFilter = ({ filterOrderSelected, onSelectFilter }) => {
  const { open, anchorRef, handleToggle, handleClose, handleListKeyDown } =
    useOrderFilter();

  return (
    <Stack direction="row" spacing={2} className="order-filter-new">
      <div>
        <button
          className="order-filter-new__button"
          ref={anchorRef}
          id="composition-button"
          aria-controls={open ? "composition-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
        >
          <Setting />
        </button>
        <Popper
          className="order-filter-new__popper"
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          placement="bottom-start"
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom-start" ? "left top" : "left bottom",
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    className="order-filter-new__menu-list"
                    autoFocusItem={open}
                    id="composition-menu"
                    aria-labelledby="composition-button"
                    onKeyDown={handleListKeyDown}
                  >
                    <MenuItem
                      className={`order-filter-new__menu-list__item ${
                        filterOrderSelected === "message" ? "active" : ""
                      }`}
                      onClick={(event) => {
                        onSelectFilter("message");
                        handleClose(event);
                      }}
                    >
                      <div className="order-filter-new__menu-list__content">
                        <MessageNotif />
                        <Typography.H5 weight={500} color={"gray-180"}>
                          Conversas recentes
                        </Typography.H5>
                      </div>
                    </MenuItem>
                    <MenuItem
                      className={`order-filter-new__menu-list__item ${
                        filterOrderSelected === "order" ? "active" : ""
                      }`}
                      onClick={(event) => {
                        onSelectFilter("order");
                        handleClose(event);
                      }}
                    >
                      <div className="order-filter-new__menu-list__content">
                        <Message2 />
                        <Typography.H5 weight={500} color={"gray-180"}>
                          Ordem de chegada
                        </Typography.H5>
                      </div>
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </Stack>
  );
};

export default OrderFilter;
